export type MemberReservationStatus = 'New' | 'Contacted' | 'Booked' | 'Closed';

export type MemberReservation = {
  rowKey: string;
  sourceType: 'ProductTrial' | 'Reservation';
  sourceId: string;
  type: string;
  typeLabel: string;
  detail: string | null;
  store: string;
  scheduleDate: string | null;
  scheduleTime: string | null;
  status: MemberReservationStatus;
  createdAt: string | null;
};

export type PaginationMeta = {
  Page: number;
  PerPage: number;
  Total: number;
  TotalPages: number;
};

type ApiMemberReservation = {
  RowKey: string;
  SourceType: 'ProductTrial' | 'Reservation';
  SourceId: string;
  Type: string;
  TypeLabel: string;
  Detail?: string | null;
  Store: string;
  ScheduleDate?: string | null;
  ScheduleTime?: string | null;
  Status: string;
  CreatedAt: string | null;
};

type ApiResponse<T> = T & { ok: boolean; message?: string };

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || '資料載入失敗，請稍後再試。');
  }
  return data as T;
}

function normalize(item: ApiMemberReservation): MemberReservation {
  return {
    rowKey: item.RowKey,
    sourceType: item.SourceType,
    sourceId: item.SourceId,
    type: item.Type,
    typeLabel: item.TypeLabel || item.Type,
    detail: item.Detail || null,
    store: item.Store || '',
    scheduleDate: item.ScheduleDate || null,
    scheduleTime: item.ScheduleTime || null,
    status: (item.Status as MemberReservationStatus) || 'New',
    createdAt: item.CreatedAt || null,
  };
}

/** 供會員中心「預約紀錄」頁面使用：合併產品試戴預約與活動預約（父親節活動、預約檢測等），依建立時間新到舊排序、分頁。 */
export async function getMemberReservations(page = 1, perPage = 10) {
  const data = await fetch(`/api/member/reservations?Page=${page}&PerPage=${perPage}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  }).then((response) => parseJsonResponse<{ ok: boolean; Items: ApiMemberReservation[]; Pagination: PaginationMeta }>(response));
  return {
    items: data.Items.map(normalize),
    pagination: data.Pagination,
  };
}

export const memberReservationStatusLabels: Record<MemberReservationStatus, string> = {
  New: '新預約',
  Contacted: '已聯絡',
  Booked: '已預約',
  Closed: '已結案',
};

export const memberReservationStatusClass: Record<MemberReservationStatus, string> = {
  New: 'bg-[#e9f4ec] text-[#245438]',
  Contacted: 'bg-[#eef3f8] text-[#255071]',
  Booked: 'bg-[#fff6df] text-[#7a5610]',
  Closed: 'bg-[#eeeeee] text-[#59635d]',
};
